// assets
import { IconDashboard, IconReportMoney, IconBuildingWarehouse, IconWeight, IconCash, IconTruck } from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
    IconDashboard: IconDashboard,
    IconReportMoney: IconReportMoney,
    IconBuildingWarehouse: IconBuildingWarehouse,
    IconWeight: IconWeight,
    IconCash: IconCash,
    IconTruck: IconTruck
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const inventbill: NavItemType = {
    id: 'inventbill',
    title: 'Warehouse and Billing',
    icon: icons.IconDashboard,
    type: 'group',
    children: [
        {
            id: 'warehouse',
            title: 'Warehouse',
            type: 'item',
            url: '/warehouse',
            icon: icons.IconBuildingWarehouse,
            breadcrumbs: false
        },
        {
            id: 'billing',
            title: 'Billing',
            type: 'item',
            url: '/billing',
            icon: icons.IconReportMoney,
            breadcrumbs: false
        }
    ]
};

export default inventbill;
